var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcProfileLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3778)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 13,
    r: 4,
    fill: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 25C9 21.6863 11.6863 19 15 19H21C24.3137 19 27 21.6863 27 25C27 26.1046 26.1046 27 25 27H11C9.89543 27 9 26.1046 9 25Z",
    fill: "#DEDEDE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3778"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcProfileLarge);
export default __webpack_public_path__ + "static/media/ic_profile_large.e07d8c1ebac148d8b38e1f9862c96809.svg";
export { ForwardRef as ReactComponent };